export default __webpack_public_path__ + "static/media/ais_top_logo.b38edd68.webp";